import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { complexFilters, createListQuery } from '#web-service-api/common';
import { GuestResponseSchema } from '../response';
export const GuestsListFiltersSchema = z.object({
    email: z.string(),
});
export const GuestsListFilters = complexFilters(GuestsListFiltersSchema);
export const GuestsListQuery = createListQuery({
    schema: GuestResponseSchema,
    sortable: {
        by: ['email', 'lastUsedAt', 'linksCount'],
        default: '-lastUsedAt',
    },
    pageSize: {
        default: 100,
        max: 100,
    },
    filters: GuestsListFilters.codec,
});
export class GuestsListQueryDto extends createZodDto(GuestsListQuery.codec) {
}
